import * as React from 'react';
import * as moment from 'moment';

import { IArenaEvent } from '../classes/event';

interface GridEventProps {
    event: IArenaEvent;
}

const gridCell: React.StatelessComponent<GridEventProps> = (props) => {
    const dateMoment = moment(props.event.eventDate);
    //console.log(dateMoment.hours());
    //console.log(props.event.additionalInfo)
    const renderAdditionals = function (additionals) {
        return (
            additionals.map((item,index)=> <p key={index}>
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-special-guest" />
                </svg>
                {item}
            </p>)
        )
    }
    return (
        <div className="grid-day-event">
            <p className="grid-day-event-time">{`${dateMoment.format("h:mm")} ${dateMoment.hours() >= 12 ? "p.m." : "a.m."}`}</p>
            <p className="grid-day-event-title">{props.event.name}</p>
            <div className="grid-day-event-details">
                {
                    props.event.additionalInfo ?
                        renderAdditionals(props.event.additionalInfo)
                        :
                       null
                }
                {
                    props.event.audioDescribed ?
                        <p>
                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-audio-described" />
                            </svg>
                            Audio Described
                        </p>
                        :
                        null
                }
                {
                    props.event.openCaptioned ?
                        <p>
                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-open-captioned" />
                            </svg>
                            Open Caption
                        </p>
                        :
                        null
                }
                {
                    props.event.wheelchairSeating ?
                        <p>
                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-wheelchair" />
                            </svg>
                            Wheelchair Seating
                        </p>
                        :
                        null
                }
                {
                    props.event.postShowDiscussion ?
                        <p>
                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-post-show-discussion" />
                            </svg>
                            Post-Show Discussion
                        </p>
                        :
                        null
                }
                {
                    props.event.bestValue ?
                        <p>
                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-best-value" />
                            </svg>
                            Best Value
                        </p>
                        :
                        null
                }

                {

                    props.event.soldOut ?
                        <button className="btn grid-day-event-cta" disabled >Sold Out</button>
                        :
                        <a className="btn grid-day-event-cta" href={props.event.buyTicketsLink}>{props.event.buyTicketsLabel}</a>
                }
            </div>
        </div>
    );
}

export default gridCell;


// WEBPACK FOOTER //
// ./app/calendar/views/grid-event.tsx